module.exports = __webpack_public_path__ + "static/media/isel-logo.8ebf2bc7.png";